import checkPassword from 'helpers/validators/checkPassword';
import { z } from 'zod';

const schema = z.object({
  firstName: z.string().min(1, { message: 'errors.field_required' }),
  lastName: z.string().min(1, { message: 'errors.field_required' }),
  organizationName: z.string().min(1, { message: 'errors.field_required' }),
  email: z.string().email({ message: 'errors.wrong_email' }),
  password: z.string().refine((value) => checkPassword(value), {
    message: 'errors.password_error',
  }),
});

export default schema;
